import React from 'react';
import classNames from 'classnames';
import Button from '../elements/Button';
import { ibashoTown as p } from '../../data/products';

const ProductIbashoTown = ({ className, ...props }) => {

  const outerClasses = classNames('section product product-it', className);

  return (
    <section {...props} id={p.id} className={outerClasses}>
      <div className="product-glow" aria-hidden="true" />
      <div className="container">
        <div className="section-inner">

          <div className="product-head reveal-from-bottom">
            <div className="product-logo product-logo-it">
              <img src="/img/ibasho/icon.svg" alt="" width={56} height={56} />
              <span className="product-wordmark">{p.name}</span>
            </div>
            <div className="product-head-text">
              <p className="product-kicker text-xxs m-0">{p.nameJa} · {p.platform}</p>
              <h2 className="product-tagline product-tagline-ja mt-8 mb-0" lang="ja">{p.sloganJa}</h2>
              <p className="product-slogan-en text-sm mt-4 mb-0">{p.slogan}</p>
            </div>
          </div>

          <div className="product-main">
            <div className="product-media reveal-from-left" data-reveal-delay="100">
              <figure className="product-map">
                <img src={p.map.src} alt={p.map.alt} width={1536} height={1024} loading="lazy" />
                <figcaption className="text-xxs" lang="ja">イバショタウン 案内マップ</figcaption>
              </figure>
            </div>

            <div className="product-copy reveal-from-right" data-reveal-delay="200">
              <p className="product-lede m-0">{p.tagline}</p>
              <p className="product-desc mt-16 mb-0">{p.description}</p>

              <div className="product-actions">
                <Button tag="a" color="primary" className="button-it" wideMobile href={p.url} target="_blank" rel="noopener noreferrer">
                  Visit Ibasho Town
                </Button>
              </div>
              <p className="text-xxs product-footnote m-0">Free to play in the browser. Japanese language. Google sign-in.</p>
            </div>
          </div>

          <ul className="product-features product-features-it list-reset">
            {p.features.map((f, i) => (
              <li key={f.title} className="product-feature reveal-from-bottom" data-reveal-delay={100 * i}>
                <span className="product-feature-ja text-xxs" lang="ja">{f.titleJa}</span>
                <h4 className="mt-0 mb-8">{f.title}</h4>
                <p className="m-0 text-sm">{f.body}</p>
              </li>
            ))}
          </ul>

          <div className="product-places">
            {p.places.map((s, i) => (
              <figure key={s.src} className="product-place reveal-from-bottom" data-reveal-delay={100 * i}>
                <img src={s.src} alt={s.alt} loading="lazy" />
              </figure>
            ))}
            <blockquote className="product-closing reveal-from-bottom" data-reveal-delay="200" lang="ja">
              <p className="m-0">ずっと待っていた<wbr />誰かに会える場所、<br />イバショタウンへ、<wbr />おいでください。</p>
            </blockquote>
          </div>

        </div>
      </div>
    </section>
  );
}

export default ProductIbashoTown;
